// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"dd506203","286":"23aa3415","556":"dd506203","769":"b0fa6d8f","789":"75b4763c"}[chunkId] + ".chunk.css";
};